<ion-content class="content">
  <ion-icon class="content__close" name="close" (click)="dismiss()"></ion-icon>
  <iframe class="content__iframe" [src]="safeUrl"></iframe>
</ion-content>
